export default __webpack_public_path__ + "8364cd6a82fce3845db975956a37f724.png";